import React from 'react';
import type { PlanTermProps } from '../context';

export type SetPlanTermProp = React.SetStateAction<PlanTermProps>;

export type ValidityKey =
  | 'dates'
  | 'number'
  | 'meetingPlace'
  | 'meetingTime'
  | 'isFreeMeeting'
  | 'firstDayStatus'
  | 'dismissalPlace'
  | 'dismissalTime'
  | 'isFreeDismissal'
  | 'lastDayStatus'
  | 'holiday'
  | 'workingTimes'
  | 'money';

export type Validity = { [key: ValidityKey]: boolean };

export type PlanTermContextProps = {
  planTerm: PlanTermProps,
  setPlanTerm: (data: SetPlanTermProp, validity: Validity) => void,
  validity: Validity,
  readOnly: boolean,
  isEditing: boolean,
  version: number,
  incrementVersion: () => void,
};

const PlanTermContext: React.Context<PlanTermContextProps> =
  React.createContext({
    planTerm: {},
    setPlanTerm: (data: SetPlanTermProp, validity: Validity) => {},
    validity: {},
    readOnly: true,
    isEditing: false,
    version: 0,
    incrementVersion: () => {},
  });

export default PlanTermContext;
